import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { RootState } from '../../../store';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../../main/left-side';
import TitleCard from '../../main/title-card';
import Card from '../../main/card';
import useTranslate from '../../useTranslate';
import {
    LoadAllLocationsForAccountingArea,
    LocationOverviewDto,
} from '../../../store/locationsSlice';
import { LoadMansions, Mansion } from '../../../store/mansionsSlice';
import Navbar from '../../navigation/navbar';
import { RequestStatus } from '../../../store/network/managedRequest';
import SelectLocationTable, {
    LocationAndMansion,
} from './select-location-table';
import { PbRequest } from '../../../store/pbRequest';
import { useNavigate } from 'react-router-dom';

interface Props {
    locations: LocationOverviewDto[];
    locationsRequestStatus: RequestStatus;
    mansions: { [key: string]: Mansion };
    LoadAllLocationsForAccountingArea: () => void;
    LoadMansions: () => void;
}

function SelectLocationSuggestedPriceScreen(props: Readonly<Props>) {
    const navigate = useNavigate();
    const [locationsPlus, setLocationsPlus] = useState<LocationAndMansion[]>(
        []
    );

    useEffect(() => {
        props.LoadAllLocationsForAccountingArea();
        props.LoadMansions();
    }, []);

    useEffect(() => {
        if (props.locationsRequestStatus !== RequestStatus.SUCCESS) {
            return;
        }

        const list: LocationAndMansion[] = props.locations
            .filter((location) => !!location.cost_increase_suggestion)
            .map((location) => ({
                location,
                mansion: props.mansions[location.mansion_id],
                targetLink: {
                    pathname: `/objects/${location.mansion_id}/${location.id}/suggested-prices`,
                },
            }));

        setLocationsPlus(list);
        if (list.length === 1) {
            const { id, mansion_id } = list[0].location;
            navigate(`/objects/${mansion_id}/${id}/suggested-prices`, {
                replace: true,
            });
        }
    }, [props.locations, props.mansions]);

    const strings = useTranslate('SelectLocationPricing');

    return (
        <Navbar nav>
            <Row>
                <LeftSide addClass="">
                    <TitleCard
                        title={strings.priceTitle}
                        left={{
                            content: (
                                <Link
                                    to={`/dashboard`}
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: strings.priceTitle,
                        }}
                    />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <Card title={strings.title}>
                        <p>{strings.description}</p>
                        <SelectLocationTable
                            locationsWithMansion={locationsPlus}
                        />
                    </Card>
                </Col>
            </Row>
        </Navbar>
    );
}

export default connect(
    (store: RootState) => ({
        locations: store.locations.allLocationsForAccountingArea,
        locationsRequestStatus:
            store.pbRequest[PbRequest.GET_ALL_LOCATIONS_FOR_ACCOUNTING_AREA]
                .status,
        mansions: store.mansions.mansionsById,
    }),
    { LoadAllLocationsForAccountingArea, LoadMansions }
)(SelectLocationSuggestedPriceScreen);
